import axios from "axios";
import Config from "../utils/Config";

class DocumentSearchService {
  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  //set access token
  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }

  //get search documents
  async getSearchAttachments(searchText, page, size, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.get(
      Config.BACKEND_URL + `/apiVWeb/meetingAgenda/searchAttachments?searchText=${searchText}&page=${page}&size=${size}`, //api/meetingAgenda/searchAttachments?searchText=test&page=1&size=10
      this.config
    );
    return data.data;
  }

  // download the document
  async createLeaves(formData, agendaId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.post(
      Config.BACKEND_URL + `/api/meetingAgenda/downloadAgendaCategoryItemAttachment/${agendaId}`, //api/meetingAgenda/downloadAgendaCategoryItemAttachment/672bd610723ec2e41e697d62
      formData,
      this.config
    );
    return data.data;
  }
};
export default new DocumentSearchService();